// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Welcome$ReactHooksTemplate = require("./Welcome.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");

function WelcomeForm(props) {
  var inlineButtonsLayout = props.inlineButtonsLayout;
  var __inlineButtonsSlot = props.inlineButtonsSlot;
  var __belowButtonsSlot = props.belowButtonsSlot;
  var __aboveButtonsSlot = props.aboveButtonsSlot;
  var __belowContentSlot = props.belowContentSlot;
  var __insideContentTopSlot = props.insideContentTopSlot;
  var substitutionVariables = props.substitutionVariables;
  var language = props.language;
  var buttonBgColor = props.buttonBgColor;
  var handleStart = props.handleStart;
  var welcome = props.welcome;
  var $$default = props.default;
  var insideContentTopSlot = __insideContentTopSlot !== undefined ? Caml_option.valFromOption(__insideContentTopSlot) : null;
  var belowContentSlot = __belowContentSlot !== undefined ? Caml_option.valFromOption(__belowContentSlot) : null;
  var aboveButtonsSlot = __aboveButtonsSlot !== undefined ? Caml_option.valFromOption(__aboveButtonsSlot) : null;
  var belowButtonsSlot = __belowButtonsSlot !== undefined ? Caml_option.valFromOption(__belowButtonsSlot) : null;
  var inlineButtonsSlot = __inlineButtonsSlot !== undefined ? Caml_option.valFromOption(__inlineButtonsSlot) : null;
  var withDefault = function ($$default, x) {
    if (x.length === 0) {
      return $$default;
    } else {
      return x;
    }
  };
  var langName = SurveyLanguage$ReactHooksTemplate.name(language);
  var rawTitle = withDefault(Welcome$ReactHooksTemplate.title($$default), Welcome$ReactHooksTemplate.getTitleTranslation(welcome, langName));
  var rawDescription = withDefault(Welcome$ReactHooksTemplate.description($$default), Welcome$ReactHooksTemplate.getDescriptionTranslation(welcome, langName));
  var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawTitle, substitutionVariables);
  var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawDescription, substitutionVariables);
  var hasDescription = rawDescription.trim() !== "";
  var buttonLabel = withDefault(Welcome$ReactHooksTemplate.button($$default), Welcome$ReactHooksTemplate.getButtonTranslation(welcome, SurveyLanguage$ReactHooksTemplate.name(language)));
  var buttonElement = JsxRuntime.jsx("button", {
        children: buttonLabel,
        className: "w-full h-48-px small:h-40-px rounded-lg text-white\n        text-base leading-4 font-semibold text-center shadow-sm",
        style: {
          backgroundColor: buttonBgColor === "" ? "rgb(43, 97, 171)" : buttonBgColor
        },
        onClick: (function ($$event) {
            $$event.preventDefault();
            Curry._1(handleStart, undefined);
          })
      });
  var buttonSection = inlineButtonsLayout !== undefined ? (
      inlineButtonsLayout === "InlineLeft" ? JsxRuntime.jsxs("div", {
              children: [
                inlineButtonsSlot,
                JsxRuntime.jsx("div", {
                      children: buttonElement,
                      className: "flex-grow min-w-0"
                    })
              ],
              className: "flex items-stretch gap-3 w-full"
            }) : JsxRuntime.jsxs("div", {
              children: [
                inlineButtonsSlot,
                JsxRuntime.jsx("div", {
                      children: buttonElement,
                      className: "flex-grow min-w-0"
                    })
              ],
              className: "flex items-stretch gap-3 flex-row-reverse w-full"
            })
    ) : JsxRuntime.jsxs("div", {
          children: [
            aboveButtonsSlot,
            buttonElement,
            belowButtonsSlot
          ],
          className: "w-full flex flex-col gap-3"
        });
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      insideContentTopSlot,
                      JsxRuntime.jsx("div", {
                            className: "survey-rich-text text-xl text-center small:text-lg w-full leading-snug",
                            dangerouslySetInnerHTML: {
                              __html: titleHtml
                            }
                          }),
                      hasDescription ? JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-l text-center small:text-sm w-full leading-relaxed",
                              dangerouslySetInnerHTML: {
                                __html: descriptionHtml
                              }
                            }) : null,
                      JsxRuntime.jsx("div", {
                            children: belowContentSlot,
                            className: "w-full"
                          }),
                      buttonSection
                    ],
                    className: "flex flex-col items-center w-full gap-4 py-4"
                  }),
              className: "flex flex-col w-full flex-grow justify-center"
            });
}

var make = WelcomeForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
